import { render, staticRenderFns } from "./TitleListView2.vue?vue&type=template&id=013bd2f9"
import script from "./TitleListView2.vue?vue&type=script&lang=js"
export * from "./TitleListView2.vue?vue&type=script&lang=js"
import style0 from "./TitleListView2.vue?vue&type=style&index=0&id=013bd2f9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports